import { render, staticRenderFns } from "./QuestionColonostomy.vue?vue&type=template&id=4a31a770&scoped=true"
import script from "./QuestionColonostomy.vue?vue&type=script&lang=js"
export * from "./QuestionColonostomy.vue?vue&type=script&lang=js"
import style0 from "./QuestionColonostomy.vue?vue&type=style&index=0&id=4a31a770&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a31a770",
  null
  
)

export default component.exports